const KEY = "opstrack_automatic_reload";
const MAX_AGE_MS = 5 * 60_000;
let pendingPath: string | null = null;

export function markAutomaticReload(): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path: window.location.pathname, at: Date.now() }));
  } catch {
    // Storage availability must never prevent deployment refresh.
  }
}

export function initializeAutomaticReload(): void {
  pendingPath = null;
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    if (!raw) return;
    const marker = JSON.parse(raw);
    const navigation = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
    const age = Date.now() - marker.at;
    if (navigation?.type === "reload" && marker.path === window.location.pathname
      && typeof marker.at === "number" && age >= 0 && age <= MAX_AGE_MS) {
      pendingPath = marker.path;
    }
  } catch {
    // Missing or malformed markers count as ordinary openings.
  }
}

export function consumeAutomaticReload(): boolean {
  const path = pendingPath;
  pendingPath = null;
  return path !== null && path === window.location.pathname;
}
